import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./NegotiationsBarListItem.css";
import "../NegotiationsBar.css";
import LoaderSpinner from '../../loaderSpinner/loaderSpinner'
import axios from "axios";
import { format } from 'date-fns';



function NegotiationsBarListItem({ onClickNegotiation, negotiationsList }) {

	const UID = useSelector(state => state.user.uid)
	const [negotiations, setNegotiations] = useState([]);
	const [loading, setLoading] = useState(true);
	const showTime = format(new Date(), 'MMddyyyyHis');

	useEffect(() => {
		//console.log(negotiationsList, onClickNegotiation, UID)
		// console.log('Function---->', onClickNegotiation);
		if (negotiationsList && Object.keys(negotiationsList).length) {
			const getNegotiationComponents = (garagePictures, garagePicturesA, negotiation, element) => {
				//	console.log('NegotiationsBarListItem', negotiation, element.currentProposal, element.currentProposalUID);
				// debugger
				return (
					<div
						key={negotiation}
						className={`negotiationsBarListItem_container ${element.ownerID === UID ? "OwnGarage" : ""}`}
						onClick={() => onClickNegotiation(element.id, element.currentProposal, element.currentProposalUID)}
					>
						<div className="negotiationsBarListItem_container_img">
							<img
								style={{ transform: `rotate(${garagePicturesA ? garagePicturesA : 0}deg)` }}
								src={`${garagePictures}?time=${showTime}`}
								alt="Garage_image"
								id="GarageImage"
							/>
						</div>
						<div className="negotiationsBarListItem_container_text">
							{element.garageAddress}
						</div>
						<div className="negotiationsBarListItem_container_text">
							<span className="negotiationsBarListItem_container_text_title">
								Rental Rate:
							</span>{" "}
							${element.currentProposal}
						</div>
						<div className="negotiationsBarListItem_container_text">
							<span className="negotiationsBarListItem_container_text_title">
								Status:
							</span>{" "}
							{element.dealClosed ? "Negotiation finished" : element.currentProposalUID === UID ? "Waiting for an Answer" : "Check this negotiation"}
						</div>
					</div>
				);
			};

			async function getNegotiations(negotiationsList) {
				//console.log('negotiationsList',negotiationsList)
				let negotiationsContainer = [];
				try {
					for (const negotiation in negotiationsList) {
						const element = negotiationsList[negotiation];


						const data = await axios.post(`${process.env.REACT_APP_API_URL}`, {
							action: 'GetGaragebyId',
							id: element.garageID,
						})
							.then(response => {
								//console.log('list')
								return response.data.data;
							})
							.catch(error => {
								console.log(error)
							});


						const urlsArray = data.garagePictures;
						const garagePicturesA = data.garagePicturesA ? data.garagePicturesA: '';
				
						let imagesURL = [];
						if (urlsArray.length>0) {

							for (const image in urlsArray) {
								imagesURL = [...imagesURL, process.env.REACT_APP_UPLOAD_URL + urlsArray[image]];
							}
						} else {
							imagesURL = ['./assets/Images/garage-placeholder.png'];
						}



						if (imagesURL[0]) {
							negotiationsContainer = [
								...negotiationsContainer,
								getNegotiationComponents(
									imagesURL[0],
									garagePicturesA[0],
									negotiation,
									element
								)
							];
						} else {
							negotiationsContainer = [
								...negotiationsContainer,
								getNegotiationComponents(
									"./assets/Images/negotiation-placeholder.png",
									0,
									negotiation,
									element
								)
							];
						}
					}
					return negotiationsContainer;
				} catch (err) {
					throw err;
				}
			}

			getNegotiations(negotiationsList).then(resp => {
				// console.log("negotiations results", resp);
				setNegotiations(() => [resp]);

				if (resp.length > 0) {
					setTimeout(() => {
						setLoading(false);
					}, 500);
				} else {
					setLoading(() => false);
				}
			});
		} else {
			setNegotiations(() => { });
			setLoading(() => false);
		}
	}, [negotiationsList, onClickNegotiation, UID]);
	// console.log("BarListItem props", props);

	return (
		loading
			? <LoaderSpinner />
			: <div className="negotiationsBarListItems">
				{negotiations
					? negotiations
					: <div className="negotiationsContainer_list_empty">
						<span className="negotiationsContainer_list_empty_title">
							You don't have any <br />
							negotiation active
						</span>
						<span className="negotiationsContainer_list_empty_subtitle">
							Begin your <br />
							negotiations <br />
							now
						</span>
					</div>
				}

			</div>
	);
}

export default NegotiationsBarListItem;
